var _rect, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignedInDisableIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.166992,
    y: 0.000976562,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_22193_80748",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 17,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.16699 8.00098H24.167V24.001H8.16699V8.00098Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_22193_80748)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.167 8.00098C20.5849 8.00098 24.167 11.5831 24.167 16.001C24.167 20.4189 20.5849 24.001 16.167 24.001C11.7491 24.001 8.16699 20.4189 8.16699 16.001C8.16699 11.5831 11.7491 8.00098 16.167 8.00098ZM18.4524 12.9085L18.4502 12.9095L16.167 15.1929L13.8838 12.9095C13.8831 12.9087 13.8827 12.9085 13.8824 12.9085C13.8821 12.9084 13.8826 12.9085 13.8824 12.9085C13.8821 12.9085 13.8813 12.9084 13.8811 12.9085C13.8806 12.9085 13.8802 12.9087 13.8795 12.9094L13.0756 13.7133C13.0754 13.7135 13.0757 13.713 13.0756 13.7133C13.0754 13.7136 13.0748 13.7146 13.0747 13.7149C13.0746 13.7151 13.0747 13.7147 13.0747 13.7149C13.0747 13.7151 13.0746 13.7159 13.0747 13.7162C13.0748 13.7164 13.075 13.7169 13.0752 13.7171C13.075 13.7169 13.0753 13.7173 13.0752 13.7171L15.359 16.001L13.0756 18.2842C13.0747 18.2849 13.0745 18.2853 13.0745 18.2856C13.0744 18.2858 13.0745 18.2854 13.0745 18.2856C13.0745 18.2858 13.0744 18.2867 13.0745 18.2869C13.0745 18.2874 13.0747 18.2878 13.0754 18.2885L13.8793 19.0924C13.879 19.0922 13.8795 19.0926 13.8793 19.0924C13.8796 19.0925 13.8806 19.0932 13.8809 19.0933C13.8807 19.0933 13.8811 19.0934 13.8809 19.0933C13.8811 19.0933 13.882 19.0934 13.8822 19.0933C13.8825 19.0933 13.8829 19.0931 13.8836 19.0924L16.167 16.809L18.4502 19.0924C18.4509 19.0931 18.4513 19.0933 18.4516 19.0933C18.4514 19.0933 18.4518 19.0934 18.4516 19.0933C18.4518 19.0933 18.4527 19.0934 18.4529 19.0933C18.4534 19.0933 18.4538 19.0931 18.4545 19.0924L19.2584 18.2885C19.2582 18.2887 19.2586 18.2883 19.2584 18.2885C19.2585 18.2882 19.2592 18.2872 19.2593 18.2869C19.2593 18.2871 19.2594 18.2867 19.2593 18.2869C19.2593 18.2867 19.2594 18.2858 19.2593 18.2856C19.2592 18.2854 19.2595 18.2858 19.2593 18.2856C19.2592 18.2854 19.2586 18.2844 19.2584 18.2842L16.975 16.001L19.2584 13.7178C19.2591 13.717 19.2593 13.7167 19.2593 13.7163C19.2593 13.7166 19.2594 13.7161 19.2593 13.7163C19.2593 13.7161 19.2594 13.7153 19.2593 13.7151C19.2593 13.7145 19.2591 13.7142 19.2584 13.7135L18.4545 12.9095C18.4543 12.9093 18.4547 12.9097 18.4545 12.9095C18.4542 12.9094 18.4527 12.9086 18.4524 12.9085Z",
    fill: "#BFBFBF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignedInDisableIcon);
export default __webpack_public_path__ + "static/media/signedInDisableIcon.a5af78a7acad99ab8f9fc7bf2efea4af.svg";
export { ForwardRef as ReactComponent };